<template>
  <span class="ac-icon" :style="boxStyle" aria-hidden="true" v-html="svg"></span>
</template>

<script>
import { lucideIcon } from '../agentIcons';

// Inline Lucide icon. `name` must be a key of LUCIDE in agentIcons.js (static markup, never user data).
export default {
  name: 'AcIcon',
  props: {
    name: { type: String, required: true },
    size: { type: Number, default: 16 },
  },
  computed: {
    svg() {
      return lucideIcon(this.name, this.size);
    },
    boxStyle() {
      return { width: `${this.size}px`, height: `${this.size}px` };
    },
  },
};
</script>

<style lang="scss" scoped>
.ac-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  line-height: 0;

  ::v-deep svg {
    display: block;
    vertical-align: initial;
  }
}
</style>
